import { GetTripMessagesResObj, TripMessageObj } from "@/types/interfaces/crm";
import axiosInstance from "../axiosInstance";
import getByTripIds from "./tripIdBatches";

/** Lower than the files cap: message bodies are unbounded text and ship in full. */
const MESSAGE_TRIP_IDS_PER_REQUEST = 100;

export async function getAdminTripMessages(tripId: number): Promise<GetTripMessagesResObj> {
  const res = await axiosInstance.get(`/crm/admin/trips/messages/${tripId}`);
  return {
    messages: res.data?.data || [],
    metaInfo: res.data?.meta || {},
  };
}

/** Sorted newest first, since the endpoint has no ORDER BY of its own. */
export async function getAdminMessagesByTripIds(tripIds: readonly (number | string)[]): Promise<TripMessageObj[]> {
  const messages = await getByTripIds<TripMessageObj>("/crm/admin/messages", tripIds, MESSAGE_TRIP_IDS_PER_REQUEST);

  // messageDate is when it happened; dateCreated stands in when a row carries no message date.
  const sortableTime = (message: TripMessageObj) =>
    new Date(message.messageDate || message.dateCreated || 0).getTime() || 0;

  return messages.sort((a, b) => sortableTime(b) - sortableTime(a));
}
